import type {
  ReadingTaskDetailRow,
  ReadingTasksTableConfigOptions,
} from './types';

const noopViewResult: (row: ReadingTaskDetailRow) => void = () => {};

export const defaultOpts: Required<ReadingTasksTableConfigOptions> = {
  iconColWidth: 58,
  detailIconIndentPx: 15,
  detailContentIndentClass: 'pl-2',

  headerBgClass: '',
  rowBgClass: '',
  headerBgInline: '',
  rowBgInline: '',
  headerTextClass: 'text-spanishGray font-medium',

  dataFontSizePx: 14,
  dataLineHeightPx: 30,

  actionIconSizeClass: 'text-[25px]',
  dateTextClass: 'text-black',
  timeTextClass: 'text-spanishGray',
  onViewResult: noopViewResult,
};
